import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFacebookliveComponent } from './simple-icons-facebooklive.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFacebookliveComponent ],
    exports:      [ SimpleIconsFacebookliveComponent ],
    bootstrap:    []
})
export class SimpleIconsFacebookliveModule {}
